import { TaskView } from './TaskView';
import { LeaderView } from './LeaderView';
import teamView, { TeamView } from './TeamView';
import { DateTime } from 'luxon';
import { MAX_DATE } from '../utils/DateUtils';

export type DashboardView = {
  pledgeAmount: number;
  individualPledgeAmount: number;
  externalPledgeAmount: number;
  cohortUserId: number;
  channel: string;
  groupId: number;
  groupName: string;
  leaders: LeaderView;
  logo: string;
  progress: { [goalId: number]: number[] };
  tasks: TaskView[];
  team: TeamView;
  needPayment: boolean;
  potAmount: number;
  groupStartDate: DateTime | string;
  availableJailCards: {
    id: number;
    cohortUserId: number;
    used: boolean;
    usedOn: Date;
  }[];
  accountabilityPartners: number[];
  currentWeekNumberIndexZero: number;
};
export type GoalSummaryView = {
  id: number;
  goalText: string;
  activity: number;
  duration: number;
  frequency: number;
  timeframe: number;
  startDate: string;
  endDate: string;
  goalsComplete: number;
};
export type SectionView = {
  id: number;
  title: string;
  description: string;
  questions: QuestionView[];
};

export const emptySection: SectionView = {
  id: -1,
  questions: [],
  title: '',
  description: '',
};

export type QuestionView = {
  id: number;
  name: string;
  text: string;
  responses: ResponseView[];
};

export type ResponseView = {
  responseType: 'MutuallyExclusive' | 'MultiSelect' | 'FreeText' | 'Goal' | 'AccountabilityPartner' | 'Dropdown';
  id: number;
  text: string;
  selected: boolean;
  textResponse: string;
};

const empty: DashboardView = {
  groupStartDate: MAX_DATE,
  cohortUserId: 0,
  potAmount: 0,
  logo: '',
  groupName: '',
  groupId: 0,
  progress: [],
  leaders: {},
  tasks: [],
  team: teamView.Empty,
  channel: '',
  pledgeAmount: 0,
  individualPledgeAmount: 0,
  externalPledgeAmount: 0,
  needPayment: false,
  availableJailCards: [],
  accountabilityPartners: [],
  currentWeekNumberIndexZero: 0,
};
const defaultExport = { Empty: empty };
export default defaultExport;
